// extracted by mini-css-extract-plugin
export default {"dialog":"DialogDeleteZone_dialog__JiqkI"};